import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { I8nProvider } from 'i18n';
import { Provider } from 'react-redux';
import store from 'state/store';

ReactDOM.render(
    <Provider store={store}>
        <I8nProvider>
            <BrowserRouter basename="/">
                <App />
            </BrowserRouter>
        </I8nProvider>
    </Provider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
